export default __webpack_public_path__ + "static/media/XEMP-6.5a6d4ea9.jpg";